import { FormBase } from 'core/components';

export default class AddressAutofillForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'addressAutofill',
				},
				{
					name: 'displayDropdown',
					value: false,
				},
			],
		};
	}
}
